<template>
  <div class="b-no-results">
    <div class="b-no-results__title">
      {{ title }}
    </div>
    <div class="b-no-results__desc">
      {{ desc }}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    desc: {
      type: String,
      default: '',
    },
  },
}
</script>
